export function numbersOnly(value: string): string {
  return value.replace(/[^0-9.]/g, '');
}

export function currencyFormat(value: string | number): string {
  const amount = typeof value === 'string' ? Number(value) : value;
  if (Number.isNaN(amount) || amount === 0) {
    return '$0';
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function shouldRenderRange(minimum: number, maximum: number): boolean {
  return minimum !== maximum && minimum > 0 && maximum > 0;
}

export function toFixedNoRounding(value: number, decimals: number): string {
  const factor = 10 ** decimals;
  const truncated = Math.trunc(value * factor) / factor;
  if (decimals === 0) {
    return Math.trunc(value).toString();
  }
  const result = truncated.toString();
  const decimalIndex = result.indexOf('.');
  if (decimalIndex === -1) {
    return `${result}.${'0'.repeat(decimals)}`;
  }
  const decimalPlaces = result.length - decimalIndex - 1;
  return decimalPlaces < decimals
    ? `${result}${'0'.repeat(decimals - decimalPlaces)}`
    : result;
}
